/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_organization_business_address_company_name_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Acme Inc.`
};

const en_organization_business_address_company_name_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Acme Inc.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const organization_business_address_company_name_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.organization_business_address_company_name_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("organization_business_address_company_name_placeholder", locale)
	if (locale === "es") return es_organization_business_address_company_name_placeholder(inputs)
	return en_organization_business_address_company_name_placeholder(inputs)
};
export { organization_business_address_company_name_placeholder as "organization.business_address.company_name_placeholder" }